import Requestor from '@/api/Requestor';
import { vworldDataInstance } from '@/api/core';
// require로 호출해야 에러 없음
// https:// github.com/AdonisLau/axios-jsonp/issues/16
const jsonpAdapter = require('axios-jsonp');
class VworldDataApi extends Requestor {
    // eslint-disable-next-line no-useless-constructor
    constructor(args) {
        super(args);
    }
    /**
     * 읍면동 단위로 구획된 경계도 api
     */
    getEupMyeonDongBoundary(dongName = '', geomFilter = {
        max: {
            x: '',
            y: '',
        },
        min: {
            x: '',
            y: '',
        },
    }) {
        const { min, max } = geomFilter;
        const domainUrl = window.location.origin;
        return this.get({
            url: `https://api.vworld.kr/req/data?service=data&request=GetFeature&data=LT_C_ADEMD_INFO&key=${process.env.VUE_APP_VWORLD_API_AUTH_KEY}&domain=${domainUrl}&format=json&attrFilter=emd_kor_nm:like:${dongName}&geomFilter=BOX(${min.x},${min.y},${max.x},${max.y})`,
            adapter: jsonpAdapter,
        });
    }
}
export default new VworldDataApi(vworldDataInstance);
